import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from '../Button';
import './index.css';
import plusIcon from '../../assets/images/plus.svg';
import minusIcon from '../../assets/images/minus.svg';


class ComingSoonOfferDisclaimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  onToggle = () => {
    this.setState({
      visible: !this.state.visible,
    });
    return false;
  };

  render() {
    const MESSAGE = 'The offering of these securities will be made only by means of an offering circular. An offering statement on Form 1-A relating to these securities has not yet been filed with the Securities and Exchange Commission. No money or other consideration is being solicited at this time with respect to this offering, and if sent in response to these materials, it will not be accepted. No securities may be sold, and no offer to buy securities can be accepted and no part of the purchase price can be received for an offering under Regulation A+ until an offering statement is qualified by the U. S. Securities and Exchange Commission, and any such offer may be withdrawn or revoked, without obligation or commitment of any kind, at any time before notice of its acceptance is given after the qualification date. An indication of interest made by a prospective investor in a Regulation A+ offering is non-binding and involves no obligation or commitment of any kind.';
    return (
      <div styleName={`comingSoonDisclaimerInfo ${this.props.centered ? 'comingSoonDisclaimerCentered' : ''}`}>
        <Button type="button" onClick={() => this.onToggle()} className="btnSecondary" style={{ border: 'none', color: '#4d88be' }}>
          {
            this.state.visible ?
              <img styleName="disclaimerToggleIcon" height="8" src={minusIcon} alt="show up icon" /> :
              <img styleName="disclaimerToggleIcon" height="8" src={plusIcon} alt="show down icon" />
          }
          <span>Disclaimer</span>
        </Button>
        {
          this.state.visible ?
            <div styleName="comingSoonDisclaimerMessage">
              {MESSAGE}
            </div> : null
        }
      </div>
    );
  }
}

const mapStateToProps = () => ({

});

const mapDispatchToProps = () => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ComingSoonOfferDisclaimer);



// WEBPACK FOOTER //
// ./src/components/ComingSoonOfferDisclaimer/index.js